<template>
  <el-row ref="editor" class="f-h f-w" v-loading="meta.loading"> </el-row>
</template>
<script>
import editorUtils, { genStructData } from "@/common/editorUtils";
import { mapGetters } from "sw-hic";
export default {
  props: {
    signRatio: Number, // 签名比例
  },
  data() {
    return {
      readonly: false, // 只读模式
      record: null, // 病历
      doc: null, // 文书
      tmpl: null, // 模板
      ver: null, // 编辑中版本
      docStruct: {}, // 文档结构
      metaData: {}, // 文档元数据
      meta: {
        loading: false,
        saving: false,
        inited: false,
        opened: false,
        waterMark: false,
        to: null,
      },
    };
  },
  computed: {
    ...mapGetters(["Enum", "dict", "dictEnum", "user", "setting", "permission"]),
  },
  mounted() {
    this.meta.inited = false;
    this.$editor = new NsoOffice();
    let oRet = editorUtils.createDomEditor(this.$editor, this.$refs.editor);
    if (oRet.id) {
      this.$message.error("编辑器创建失败！");
      console.log("编辑器创建失败！", oRet);
      return;
    }

    this.initEditorEvent();
    this.$editor.NewFile();

    // 解决老系统不能自动调整大小
    let _this = this;
    let times = 5;
    let res = setInterval(() => {
      _this.resize();
      times--;
      if (times <= 0) {
        clearInterval(res);
      }
    }, 3000);
  },
  beforeDestroy() {
    this.$utils.log("unload Editor");
    editorUtils.removeDomEditor(this.$editor, this.$refs.editor);
  },
  methods: {
    initEditorEvent() {
      let _this = this;
      // 事件，文档加载完成
      this.$editor.NsoFileOpenCompleted = () => {
        _this.$editor.SetDebug(false);
        _this.$utils.log("编辑器已打开文件", "只读：", _this.readonly);
        if (!_this.meta.inited) {
          _this.$editor.CloseFile();
          _this.meta.inited = true;
          let ret = _this.$editor.GetBuildVersion();
          console.log(`当前编辑器版本：${ret?.buildVersion}`);
        }
        _this.resize();
        // 设置编辑用户
        _this.$editor.SetUserInfo({
          UserCode: _this.user.code,
          UserName: _this.user.name,
          Department: _this.user.deptName,
          TrackColor: "00BFFF",
          TrackMark: 0,
        });
        // 设置文档按宽度显示
        if (_this.setting.defaultWidth) {
          _this.$editor.SetViewProportion(4, _this.setting.defaultWidth);
        } else {
          _this.$editor.SetViewProportion(3);
        }
        // 设置边框
        if (_this.readonly) {
          _this.$editor.SetToolBarsVisible("All", false); // 编辑栏
          _this.$editor.SetLeftPanelVisible(false); // 左侧栏
          _this.$editor.SetRPropWindowVisible(false); //　右侧栏
          _this.$editor.SetRulersVisible(false); //　标尺
          _this.$editor.BrowseTemplet({ canEdit: false });
          _this.$editor.SetEditMode(0);
          // 只读的时候，如果是草稿，加水印
          if (_this.meta.waterMark) {
            _this.$editor.SetTextWaterMark({
              Text: "草稿",
              FontName: "Arial",
              FontSize: 40,
              Color: "CD2626",
              SemiTransparent: true,
              Bold: true,
              Italic: false,
              Underline: false,
              Layout: 0,
            });
          }
          return; // 只读时候，处理到此为止
        } else {
          _this.$editor.SetToolBarsVisible("All", true); // 编辑栏
          _this.$editor.SetLeftPanelVisible(true); // 左侧栏
          _this.$editor.SetRPropWindowVisible(true); //　右侧栏
          _this.$editor.SetRulersVisible(true); //　标尺
          _this.$editor.SetToolBarItemVisible("插入结构", false);
        }
        // 把 Editor 传给外边需要的组件
        _this.$bus.$emit("IDE-HELP-INPUT-READY", _this.$editor);

        // 如果是新建病历，则初始化元素（用元数据填充控件值）
        if (_this.ver && !_this.ver.id && _this.ver.ver == 1) {
          _this.initMeta().then(() => _this.initEle(true));
        }

        // 抽取文档结构
        _this.genStruct();

        // 激活事件
        _this.$editor.InitEvents();

        // 事件：焦点进入了控件
        _this.$editor.Events.NewControl.NsoNewControlCursorEnter = (evt) => {
          _this.$utils.log(evt);
          if (evt?.ObjectProp?.dataName) {
            // _this.queryHelp(evt.ObjectProp.dataName);
            _this.$bus.$emit("IDE-HELP-INPUT-QUERY", evt.ObjectProp.dataName, _this.$editor);
          }
        };
        // 事件：焦点离开了控件（方向键）
        _this.$editor.Events.NewControl.NsoNewControlCursorLeave = (evt) => { };

        _this.meta.loading = false;
        // 事件：鼠标左键
        // _this.$editor.Events.Mouse.NsoLButtonDown = (evt) => {
        //   _this.queryHelp(evt.ObjectName);
        // };
        // 事件：关闭文档
        // _this.$editor.Events.NsoFileClosingEvent = (evt) => {
        //   _this.isOpen = false
        // }
      };
    },
    // 打开文书版本
    open(ver, doc, record, tmpl, editable) {
      clearTimeout(this.meta.to);
      if (!this.meta.inited) {
        this.meta.to = setTimeout(() => this.open(ver, doc, record, tmpl, editable), 1000);
        return;
      }
      this.$utils.log(`打开文书版本：`, ver.docText, tmpl.code, editable, this.meta.opening);
      this.ver = ver;
      this.doc = doc;
      this.record = record;
      this.tmpl = tmpl;
      this.doc.tmplName = tmpl.name; // 这是为了生成结构化数据时用的，并不会保存到数据库
      this.meta.times++;

      this.openFile(ver.content, editable);
    },
    // 打开看任意文件
    openFile(content, editable, waterMark) {
      this.readonly = !editable;
      if (!this.meta.inited) {
        setTimeout(() => this.openFile(content, editable, waterMark, this.meta.times), 1000);
        return;
      }

      this.meta.waterMark = !!waterMark;
      let oret = this.$editor.OpenFile(content, 2, editable ? 2 : 0);
      if (oret.id) {
        console.log("编辑器加载文书失败！", oret);
      } else {
        this.meta.opened = true;
      }
    },
    applyFile(content) {
      this.$editor.JumpToFileEnd();
      this.$editor.MergeFile(content, false, false, e => {
        console.log(e.structList)
      });
    },
    closeFile() {
      if (!this.meta.opened) {
        return;
      }

      this.meta.opened = false;
      try {
        this.$editor.CloseFile();
      } catch (error) {
        console.log("编辑器关闭error:", error);
      }
      this.$utils.log("编辑器关闭文件");
      this.metaData = {};
      this.ver = null;
      this.doc = null;
      this.record = null;
      this.tmpl = null;
    },
    saveFile(isSubmit) {
      return new Promise((resolve, reject) => {
        if (!this.meta.opened) {
          reject("编辑器未加载文件");
          return;
        }
        let oet = this.$editor.IsDocModified();
        if (oet.id) {
          reject(`编辑器保存失败: ${oRet.desc}`);
        }

        if (!oet.isDocModified && !this.setting.isSimple) {
          reject(`未修改`);
        }
        // 结构化数据
        this.genStruct();
        this.ver.docStructure = JSON.stringify(this.docStruct);
        this.ver.docText = this.docStruct.allText;
        this.$utils.log("文书文本：", this.ver.docText);
        // bin
        let oRet = this.$editor.SaveFile("bin");
        if (oRet.id != 0) {
          reject(`编辑器保存失败: ${oRet.desc}`);
        }
        this.ver.content = oRet.base64;
        if (isSubmit) {
          // pdf
          this.$editor.SaveFile("pdf", (e) => {
            if (e.id != 0) {
              reject(`编辑器保存失败: ${e.desc}`);
            } else {
              if (this.ver) {
                if (this.ver.pdfUrl) {
                  this.ver.pdfUrlOrigin = this.ver.pdfUrl;
                }
                this.ver.pdfUrl = e.url;
              }
              resolve(this.ver);
            }
          });
        } else {
          resolve(this.ver);
        }
      });
    },
    // saveFile() {
    //   return new Promise((resolve, reject) => {
    //     let oRet = this.$editor.SaveFile("bin");
    //     if (oRet.id != 0) {
    //       reject(`编辑器保存失败: ${oRet.desc}`);
    //     } else {
    //       resolve(oRet.base64);
    //     }
    //   });
    // },
    async savePdf() {
      // 没有配置ideServer，就不另存了（因为下载不到）
      if (!this.setting.ideServer) {
        this.ver.pdfUrl = JSON.stringify({ name: this.tmpl.name, url: this.ver.pdfUrl });
        return;
      }
      // 删除旧的
      if (this.ver.pdfUrlOrigin) {
        try {
          let url = JSON.parse(this.ver.pdfUrlOrigin);
          if (url.id) {
            this.$api.Attachment.del(url.id);
          }
        } catch (e) { }
      }
      // 另存到我们的存储微服务
      let { code, name } = this.tmpl;
      try {
        let param = new FormData(); //创建form对象
        param.append("mainId", this.record.id);
        param.append("source", encodeURI(`${this.setting.ideServer}${this.ver.pdfUrl.replace("/mreditor", "")}`));
        param.append("sys", "emr");
        param.append("business", this.tmpl.name);
        let { id, url } = await this.$api.Attachment.save(param);

        this.ver.pdfUrl = JSON.stringify({ code, name, id, url });
      } catch (e) {
        console.log(e);
        this.ver.pdfUrl = JSON.stringify({ code, name, url: this.ver.pdfUrl });
      }
    },
    async save(isSubmit) {
      if (!this.ver) {
        return;
      }
      this.$utils.log("开始保存");
      this.meta.saving = true;
      // this.$editor.AcceptRecension()
      try {
        await this.saveFile(isSubmit);
        if (isSubmit) {
          await this.savePdf();
        }
        // 保存版本
        // 版本不是新的，只保存版本
        // if (this.ver.id) {
        //   // 文书对象在版本保存时，后端会关联更新，因此这里不需要更新
        //   this.ver.lockKey = (await this.$api.MrVer.save(this.ver)).lockKey;
        //   // this.$utils.log("文书版本已保存");
        // } else {
        //   // 新版本，保存版本和文书
        //
        //   let ver = await this.$api.MrVer.save(this.ver);
        //   this.ver.id = ver.id;
        //   this.ver.lockKey = ver.lockKey;
        //   // this.$utils.log("文书版本已保存");
        //   // this.doc.lockKey = (await this.$api.Mr.patch({ id: this.doc.id, editingVerId: ver.id, qcState: this.Enum.MrQCState.待质控 })).lockKey;
        //   // this.$utils.log("文书已保存");
        //   // await this.$api.Struct.save(this.tmpl.code, this.doc.id, ideResult.doc);
        //   // this.$utils.log("结构化数据已保存！");
        //   // // 保存结构化数据到his
        //   // structDataFuns.exportStructDataToHis(this.record.id, this.$cfg.sys, this.user);
        // }
        // 结构化对象，文书会在解锁时候后端更新，这里不需要更新
        let ver = await this.$api.MrVer.save(this.ver);
        this.ver.id = ver.id;
        this.ver.lockKey = ver.lockKey;
        this.$editor.SetDocModified(false);
        this.$message.success("文书已保存!");
      } catch (err) {
        throw err;
      } finally {
        this.meta.saving = false;
      }
      return this.ver;
    },
    genStruct() {
      this.docStruct = genStructData(this.$editor, this.record, this.doc, this.ver);
      this.$bus.$emit("IDE-STRUCT-GENERATED", this.docStruct);
      this.$utils.log("结构化数据:", this.docStruct);
    },
    async initMeta() {
      this.$utils.log("加载元数据");
      try {
        this.$emit("extract", true);
        this.metaData.main = this.record;
        this.metaData.mr = this.doc;
        this.metaData.user = this.user;
        if (!this.tmpl || !this.tmpl.apis) {
          return;
        }
        let apiCodes = JSON.parse(this.tmpl.apis);
        this.meta.loading = true;
        let res = await this.$api.Api.query();
        let initApis = [];
        apiCodes.forEach((code) => {
          let initApi = res.items.find((item) => item.code == code);
          if (initApi) {
            initApis.push(initApi);
          }
        });
        this.$utils.List.sort(initApis, "seqNo", true);
        this.$utils.log("元数据接口：", initApis);

        for (let i = 0; i < initApis.length; i++) {
          let initApi = initApis[i];
          // 追加到元数据的属性的名字
          let keyCode = initApi.code;
          if (initApi.struct) {
            try {
              keyCode = JSON.parse(initApi.struct).code;
            } catch (err) {
              console.log("元数据接口结构化数据解析失败：", err, initApi.struct);
            }
          }
          if (this.metaData[keyCode]) {
            console.log("元数据已存在，将被覆盖：", keyCode, this.metaData[keyCode]);
          }
          initApi.url = this.genUrl(initApi.path);
          try {
            let result = await this.$api.Api.exec(initApi.url);
            this.metaData[keyCode] = editorUtils.getDeepValue(result, initApi.unpack || ".");
            this.metaData[keyCode] = this.transfer(this.metaData[keyCode], initApi);
          } catch (err) {
            this.metaData[keyCode] = {};
            if (err) console.log("error:", err);
          }
        }
        this.$utils.log(this.metaData);
      } catch (error) {
        console.log("error:", error);
      } finally {
        this.meta.loading = false;
        this.$emit("extract", false);
      }
    },
    async initEle(isRefresh) {
      this.$utils.log("初始化控件");
      let oRet = this.$editor.GetStructsName(1, 1); // 获取所有病历段
      if (!oRet.structsName) {
        return;
      }
      if (isRefresh) {
        oRet.structsName.forEach((n) => {
          let ele = editorUtils.getEle(this.$editor, n.Name);
          // 删除所有克隆出来的病历段，只保留原始的
          if (editorUtils.isKnown(ele.isClone)) {
            this.$editor.DeleteRegion(ele.name, 3);
          } else {
            this.$editor.SetRegionProperty(ele.name, { loaded: false });
          }
        });
        oRet = this.$editor.GetStructsName(1, 1); // 获取所有病历段
      }
      // this.$utils.log(oRet.structsName);
      let completed = this.regSycle(oRet.structsName);
      let times = 0;
      while (!completed) {
        oRet = this.$editor.GetStructsName(1, 1);
        completed = this.regSycle(oRet.structsName);
        times++;
        if (times > 100) {
          break; // 防止死循环
        }
      }
      oRet = this.$editor.GetStructsName(1, 3); // 获取所有元素
      oRet.structsName.forEach((n) => {
        this.controlLoadData(n.Name);
      });

      this.tableLoadData(isRefresh); // 表格
      this.$editor.JumpToPage(1, 0); // 跳到页头
    },
    regSycle(regs) {
      let completed = true;
      regs.forEach((reg) => {
        let ele = editorUtils.getEle(this.$editor, reg.Name);
        if (!editorUtils.isKnown(ele.loaded)) {
          completed = false;
          let parent = editorUtils.getEleParent(this.$editor, reg.Name);
          if (parent) {
            if (parent.loaded) {
              this.regLoadData(parent.metaData, ele);
            }
          } else {
            this.regLoadData(this.metaData, ele);
          }
        }
      });

      return completed;
    },
    regLoadData(struct, ele) {
      this.$utils.log("给元素赋值");
      this.$utils.log(ele);
      let _this = this;
      let dataName = ele.dataName;
      let oRet;
      let metaData = editorUtils.getDeepValue(struct, ele.getRes);
      if (Array.isArray(metaData) && metaData.length) {
        this.$utils.log("绑定数据是个数组");
        oRet = this.$editor.SelectOneStruct(ele.name, false);
        oRet = this.$editor.CopyWithStruct(true);
        if (!oRet.id) {
          this.$utils.log("已经拷贝原始元素");
        }
        let idx = 1;
        metaData.forEach((mData) => {
          mData.idx = idx++;
          if (!ele) {
            oRet = this.$editor.PasteWithStruct();
            if (!oRet.id) {
              this.$utils.log("已经粘贴动态生成元素");
            }
            let names = oRet.structNames.split(";");
            ele = editorUtils.getEle(_this.$editor, names[0]);
            if (ele) {
              _this.$editor.SetRegionProperty(ele.name, { isClone: true });
              // _this.$editor.SetRegionProperty(ele.name, { dataName: dataName });
            }
            // ele = editorUtils.getEle(_this.$editor, names[0]);
            // this.$utils.log("已经重新设置")
            this.$utils.log(ele);
          }
          if (ele) {
            _this.$editor.SetRegionProperty(ele.name, { metaData: mData });
            _this.$editor.SetRegionProperty(ele.name, { loaded: true });
            _this.$editor.CursorJumpOutofOneStruct(ele.name, true);
          }
          ele = null;
        });
      }
      if (ele) {
        _this.$editor.SetRegionProperty(ele.name, { metaData: metaData });
        _this.$editor.SetRegionProperty(ele.name, { loaded: true });
      }
    },
    controlLoadData(name) {
      let ele = editorUtils.getEle(this.$editor, name);
      if (!ele) {
        return;
      }
      let parent = editorUtils.getEleParent(this.$editor, name);
      let val;
      if (parent) {
        val = editorUtils.getDeepValue(parent.metaData, ele.getRes);
      } else {
        val = editorUtils.getDeepValue(this.metaData, ele.getRes);
      }
      if (val) {
        if (editorUtils.isSelectControl(ele.type)) {
          this.$editor.SetNewControlProperty(ele.name, { Value: val });
        } else {
          this.$editor.SetNewControlText(ele.name, val.toString());
        }
      }
    },
    tableLoadData(isRefresh) {
      let oRet = this.$editor.GetStructsXmlInfoByParament(1, true, true, "Allproperty", "Allproperty", "Allproperty");
      let valtable = editorUtils.getTableFromXml(oRet.structsXml);
      valtable.forEach((tb) => {
        tb.id = tb.id.toString();
        oRet = this.$editor.GetTableProperty(tb.id, ["getRes", "cols"]);
        if (oRet.id == 0 && oRet.props.cols) {
          let cols = JSON.parse(oRet.props.cols);
          let rows = editorUtils.getDeepValue(this.metaData, oRet.props.getRes);
          if (rows && rows.length) {
            if (!isRefresh) {
              oRet = this.$editor.InsertRows(tb.id, 2, rows.length - 1);
            }

            oRet = this.$editor.GetTableColCount(tb.id);
            let cnt = oRet.colCount;
            let cellNames = [];
            let cellVals = [];
            let rowIdx = 2;
            rows.forEach((row) => {
              for (let c = 0; c < cnt; c++) {
                let colIdx = String.fromCharCode("A".charCodeAt() + c);
                oRet = this.$editor.GetCellContent(tb.id, `${colIdx}1`);
                let colName = oRet.cellContent;
                let col = cols.find((c) => c.name == colName);
                let colVal = rows[rowIdx - 2][col.field];
                if (colVal) {
                  cellNames.push(`${colIdx}${rowIdx}`);
                  cellVals.push(colVal);
                  // this.$editor.PutCellContent(tb.id, `${colIdx}${rowIdx}`, rows[rowIdx - 2][col.field])
                }
              }
              rowIdx++;
            });

            oRet = this.$editor.PutCellContentByArray(tb.id, cellNames, cellVals);
            // this.$utils.log(oRet);
          }
        }
      });
    },
    genUrl(path) {
      let paraGrps = [...path.matchAll(/{(.*?)}/g)];
      if (paraGrps) {
        paraGrps.forEach((g) => {
          let para = g[1];
          path = path.replace(`{${para}}`, editorUtils.getDeepValue(this.metaData, para));
        });
      }
      return path;
    },
    async refreshMeta() {
      try {
        this.meta.loading = true;
        let res = await this.$confirm("即将重新初始化文档，针对当前文档的所有修改可能会被覆盖！是否仍要执行？", "强制刷新", { type: "warning" });
        if (res) {
          this.metaData = {};
          await this.initMeta();
          this.initEle(true);
        }
      } catch (error) {
      } finally {
        this.meta.loading = false;
      }
    },
    print() {
      // let oRet = this.$editor.GetEditMode()
      // let mode = oRet.editMode
      this.$editor.BrowseTemplet({ OnlyPlaceHolder: false, CanEdit: false });
      this.$editor.Preview();

      if (!this.readonly && this.doc) {
        this.$editor.BrowseTemplet();
        console.log("readonly", this.readonly, "quit浏览模板");
      }
      // this.$editor.SetEditMode(mode)
    },
    resize() {
      this.$nextTick(() => {
        // 调整编辑器大小，占满剩余区域
        try {
          let oRet = this.$editor.GetSize();
          oRet = this.$editor.SetSize(this.$refs.record.$el.clientWidth, this.$refs.record.$el.clientHeight - 4);
        } catch (err) {
          // this.$utils.log(err)
        }
      });
    },
    download(fileType) {
      let _this = this;
      let ret = this.$editor.SaveFile(fileType, (e) => {
        if (e.id) {
          _this.$message.error("保存时发生错误，下载失败！");
        } else {
          window.open(e.url, "_blank");
        }
      });
      if (fileType == "bin") {
        editorUtils.downloadBin(ret.base64, `${this.$utils.Dict.text(this.doc.tmplCode, "MrTemplate")}.bin`);
      } else if (fileType == "html") {
        editorUtils.downloadHtml(ret.html, `${this.$utils.Dict.text(this.doc.tmplCode, "MrTemplate")}.html`);
      }
    },
    // 插入签名图片
    insertImg(imgStr) {
      let oRet = this.$editor.SetEditMode(2);
      this.$utils.log("设置可编辑模式2", oRet);
      oRet = this.$editor.InsertNewParagraph();
      this.$utils.log("插入新段落", oRet);
      oRet = this.$editor.SetParagraphProperty({
        Alignment: 3,
      });
      this.$utils.log("设置段落属性", oRet);
      oRet = this.$editor.SetParaLineSpacing(15);
      this.$utils.log("设置行间距 15", oRet);
      oRet = this.$editor.InsertImage({
        Content: imgStr,
        IsSignature: false,
        IsActiualSize: false,
        Width: 1700,
        Height: this.signRatio ? 1700 * this.signRatio : 600,
      });
      this.$utils.log("插入图片", oRet);
      if (oRet.id) {
        oRet = this.$editor.GetEditMode();
        this.$utils.log("查看模式", oRet);
      } else {
        this.$editor.SetImageProperty(oRet.picId, { DeleteProtect: false, PositionProtect: false, SizeProtect: false, CopyProtect: true });
        this.$utils.log("设置图片属性", oRet);
      }
    },
    // 插入签名
    insertName() {
      if (this.user.defaultImg) {
        this.insertImg(this.user.defaultImg.replace("data:image/jpg;base64,", ""));
        return;
      }
      let oRet = this.$editor.SetEditMode(2);
      this.$utils.log("设置可编辑模式2", oRet);
      oRet = this.$editor.InsertNewParagraph();
      this.$utils.log("插入新段落", oRet);
      oRet = this.$editor.SetParagraphProperty({
        Alignment: 3,
      });
      this.$utils.log("设置段落属性", oRet);
      oRet = this.$editor.SetParaLineSpacing(15);
      this.$utils.log("设置行间距 15", oRet);
      oRet = this.$editor.InsertText(this.user.name, 0);
      this.$utils.log("插入医生姓名", oRet);
      if (oRet.id) {
        oRet = this.$editor.GetEditMode();
        this.$utils.log("查看模式");
        this.$utils.log(oRet);
      }
    },
    getSelectedText() {
      let oRet = this.$editor.GetSelectText();
      return oRet.Text.replace("\r\n", "");
    },
    transfer(obj, initApi) {
      // 翻译字典、格式化日期、时间
      if (!initApi?.struct) {
        return obj;
      }
      try {
        let struct = JSON.parse(initApi.struct);
        let props = struct.props;
        if (struct.type == "list") {
          props = struct.item.props;
        } else {
          obj = [obj];
        }

        for (let o of obj) {
          for (let p of props) {
            if (p.type == "list") {
              o[p.code] = this.transfer(o[p.code], p);
            } else if (p.type == "dict") {
              o[p.code] = this.$utils.Dict.text(o[p.code], p.dict);
            }
          }
        }
        if (struct.type == "list") {
          return obj;
        }
        return obj[0];
      } catch (err) {
        console.log(err);
        return obj;
      }
    },
    apply(txt) {
      this.$editor.InsertText(txt, 0);
    },
  },
};
</script>
